var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2V20C2.75 20.6904 3.30964 21.25 4 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V2C1.25 1.58579 1.58579 1.25 2 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C10 18.6569 8.65685 20 7 20C5.34315 20 4 18.6569 4 17C4 15.3431 5.34315 14 7 14C7.90295 14 8.71272 14.3989 9.26271 15.0301L12.0659 13.6285C12.0227 13.4258 12 13.2156 12 13C12 11.3431 13.3431 10 15 10C15.2735 10 15.5385 10.0366 15.7904 10.1052L17.2964 7.46968C16.5132 6.92837 16 6.02411 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5C22 6.65685 20.6569 8 19 8C18.9083 8 18.8175 7.99588 18.7279 7.98783L17.0923 10.8501C17.6522 11.3951 18 12.1569 18 13C18 14.6569 16.6569 16 15 16C14.0971 16 13.2873 15.6011 12.7373 14.9699L9.93406 16.3715C9.97726 16.5742 10 16.7844 10 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart1);
export default __webpack_public_path__ + "static/media/bar-chart-1.e8c1ef6c15850ce7098de3a737095ef8.svg";
export { ForwardRef as ReactComponent };